export const agentStatusLight: any = {
    Available: 'positive',
    'Away': 'notice',
    'Start of Day': 'neutral',
    Break: 'notice',
    Meal: 'notice',
    Meeting: 'notice',
    Training: 'notice',
    'On Chats': 'notice',
    Project: 'notice',
    'VPN Disconnect': 'notice'
};

export const agentStatusCategory: any = {
  Available: 'available',
  'Start of Day': 'startOfDay',
  Break: 'away',
  Meal: 'away',
  Meeting: 'away',
  Training: 'away',
  'On Chats': 'away',
  Project: 'away',
  'VPN Disconnect': 'away'
}